import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3b6eace"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_2 = { class: "progress h-20px w-100" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-dark me-2 fs-6 fw-bold text-nowrap ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.total > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "progress-bar progress-bar-striped bg-success",
            style: _normalizeStyle({ width: _ctx.paidPercentage + '%' })
          }, null, 4),
          _createElementVNode("div", {
            class: "progress-bar progress-bar-striped bg-danger",
            style: _normalizeStyle({ width: _ctx.unpaidPercentage + '%' })
          }, null, 4)
        ]),
        (_ctx.salaryData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.label), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}